import { BigNumber, BigNumberish, ethers } from 'ethers';

export default function formatUnits(
  value: BigNumberish,
  decimals: BigNumberish,
  maxDecimalDigits?: number
) {
  const mValue = BigNumber.from(value);
  const mDecimals = ethers.BigNumber.from(decimals).toNumber();
  const mFixedNumber =
    mDecimals > 18
      ? ethers.FixedNumber.fromValue(mValue, mDecimals, mDecimals)
      : ethers.FixedNumber.from(ethers.utils.formatUnits(mValue, decimals));
  return mFixedNumber.round(maxDecimalDigits ?? mDecimals).toString();
}
